<template>
    <el-table
        :data="tableData"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :cell-style="{
            'font-size': '16px',
            color: '#333',
        }"
        :header-cell-style="{
            'background-color': '#e8eff9',
            'font-weight': '700',
            color: '#333',
            'font-size': '16px',
        }"
    >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
            label="ID"
            align="center"
            header-align="center"
            prop="ID"
        >
        </el-table-column>
        <el-table-column
            label="开班批次/班级编码"
            prop="classCode"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="姓名"
            prop="uname"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="手机号（账号）"
            prop="phone"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="准考证号"
            prop="admissionCard"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="加入时间"
            prop="joinTime"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="学生来源"
            prop="stuSource"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="合作院校"
            prop="schoolName"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="合作机构"
            prop="companyName"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="操作"
            prop="studyNum"
            align="center"
            header-align="center"
        >
        </el-table-column>
    </el-table>
</template>

<script>
import {
    getStudentList,
    exportStudentList,
} from "@/api//FaceToTeach/classTimeapi.js";
export default {
    data() {
        return {
            tableData: [],
            multipleSelection: [],
        };
    },
    methods: {
        async init() {
            const res = await getStudentList({
                teacherCourseBatchId: this.courseId,
            });
            this.tableData = res.data.data.list;
        },
        // 表格选中
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
    },
    created() {
        this.init();
    },
    props: {
        courseId: {
            type: String,
        },
        selectTableData: {
            type: Array,
        },
        page: {
            type: Object,
        },
    },
    watch: {
        selectTableData: function () {
            this.tableData = this.selectTableData;
        },
        page: {
            immediate: true,
            deep: true,
            handler: async function (newValue) {
                if (newValue) {
                    const res = await getStudentList({
                        teacherCourseBatchId: this.courseId,
                        page: newValue.page,
                        pageSize: newValue.pageSize,
                    });

                    this.tableData = res.data.data.list;
                    this.$emit("total", this.tableData.length);
                }
            },
        },
    },
};
</script>



